import { createSelector } from 'reselect';
import get from 'lodash/get';

import { DEFAULT_POWERED_VISIBILITY } from './ui.constants';

const isSmallScreen = (state) => state.ui.winWidth < 576;

const isMediumScreen = (state) => state.ui.winWidth < 768;

const isXLargeScreen = (state) => state.ui.winWidth >= 1200;

const isAlertVisible = (state) => !!state.ui.alertMessage;

const getHasNavbar = (state) => state.ui.hasNavbar;

const getOwnersPortalMeta = (state) => state.ui.meta;

const getOwnersPortalShowReservationTooltipFullName = createSelector(
  [getOwnersPortalMeta],
  (meta) => get(meta, ['showReservationTooltipFullName'], true)
);
/**
 * @description gets setted or default `Powered By` visibility
 * @param {object} state
 * @returns {boolean} is `Powered By` visible
 */
const getPoweredByVisibility = (state) =>
  state.ui.meta?.whiteLabel?.active
    ? !state.ui.meta.whiteLabel.poweredByGuesty
    : DEFAULT_POWERED_VISIBILITY;

/**
 * @description gets company logo url
 * @param {object} state
 * @returns {string} company logo url
 */
const getCompanyLogo = (state) =>
  state.ui.meta && state.ui.meta.accountId.companyLogo;

// xs 0   - 575
// sm 576 - 767
// md 768 - 991
// lg 992 - 1199
// xl 1200+

export {
  isSmallScreen,
  isMediumScreen,
  isXLargeScreen,
  isAlertVisible,
  getPoweredByVisibility,
  getCompanyLogo,
  getHasNavbar,
  getOwnersPortalMeta,
  getOwnersPortalShowReservationTooltipFullName,
};
